import { styled } from 'styled-components';

import { device } from '@/styles/helpers';

export const ScCardRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  position: relative;
  width: 100%;

  @media (${device.desktop}) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (${device.mobile}) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
export const ScAllOffers = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  @media (${device.mobile}) {
    align-items: center;
  }

  .no-offers {
    text-align: center;
  }
`;
